<template>
  <a-spin size="large" :spinning="loading">

  <div class="device-list con">
    <header>
      <h1>{{ $t('page_extranet_Machine_list') }} </h1>
      <a-icon class="right-icon" :class="loading ? 'refresh':''" type="sync" @click="refreshDeviceList"/>
    </header>
    <div class="search">
      <a-tree-select
          style="width: 290px;margin-right: 4px"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="treeData"
          placeholder="全部"
          :value="selectedKeys"
          :load-data="onLoadData"
          :selectedKeys="selectedKeys"
          :expandedKeys="expandedKeys"
          :defaultExpandedKeys="treeExpandedKeys"
          @select="selectTree"
          v-if="isMachineTenant"
      />
      <a-select
          :value="statusSearch"
          style="width: 290px;margin-right: 4px"
          @change="handleChangeStatus"
      >
        <a-select-option value="3">
          {{ $t('page_plan_maintenance_all_states') }}
        </a-select-option>
        <a-select-option value="2">
          {{ $t('page_extranet_In_diagnosing') }}
        </a-select-option>
        <a-select-option value="1">
          {{ $t('page_extranet_Ready') }}
        </a-select-option>
        <a-select-option value="0">
          {{ $t('page_extranet_unReady') }}
        </a-select-option>
      </a-select>
      <!-- :allow-clear="true" -->
      <a-input-search v-model="searchKey"
                      :placeholder="$t('keyword')"
                      :enter-button="$t('search')"
                      @search="handleChangeSearch"
      />
    </div>

    <div
        class="machine clearfix"
        v-infinite-scroll="handleInfiniteOnLoad"
        :infinite-scroll-disabled="loading"
        :infinite-scroll-distance="10"
    >
      <ul v-if="data&&data.length" class="list-panel" id="listPanel">
        <li
            v-for="machine of data"
            :key="machine.id"
            @click="changeCurrentDevice(machine)"
            :class="{selected: machine.id === current.id}"
        >
          <template v-if="machine.userVisibleStatus === 2">
            <!--设备诊断码与websocket握手包返回的code一致时，则为本机连接中-->
            <div v-if="socket && socket.code===machine.extranetCode"
                 class="local-extranet">
              <a-badge status="processing" :text="$t('page_extranet_Local')"></a-badge>
            </div>
            <!--非本机连接中-->
            <div v-if="machine.extranetCode" class="flag working">{{ $t('page_extranet_In_diagnosing') }}</div>
          </template>

          <!-- userVisibleStatus: 0未就绪/1就绪/2连接中-->
          <template v-if="machine.userVisibleStatus === 1">
            <div class="flag">{{ $t('page_extranet_Ready') }}</div>
          </template>
          <template v-if="machine.userVisibleStatus === 0">
            <div class="flag err">{{ $t('page_extranet_unReady') }}</div>
          </template>

          <div class="pic">
            <img :src="machine.avatar" v-if="machine.avatar"/>
            <img :src="require('@/assets/images/default-device.png')" v-else alt=""/>
          </div>
          <a-tooltip :title="machine.name" placement="right" class="name ellipsis">
            {{ machine.name }}
          </a-tooltip>
          <a-tooltip :title="machine.equipmentSerialNumber" placement="right" class="serial-no ellipsis">
            {{ machine.equipmentSerialNumber }}
          </a-tooltip>
        </li>
        <li v-if="data.length>20&&data.length<total" style="width: 100%;height: 30px;line-height:30px;">加载更多...</li>
      </ul>
      <template v-else>
        <div class="empty">
          <img :src="require('@/assets/images/noDevice.png')"/>
          <p>{{ $t('page_extranet_no_device') }}</p>
        </div>
      </template>
    </div>
<!--
    <a-skeleton :title="false" :paragraph="{ rows: 20, width: '100%' }" :loading="loading" active>
      <div class="machine clearfix">
        <ul v-if="data&&data.length" class="list-panel" id="listPanel">
          <li
                  v-for="machine of data"
                  :key="machine.id"
                  @click="changeCurrentDevice(machine)"
                  :class="{selected: machine.id === current.id}"
          >
            <template v-if="machine.userVisibleStatus === 2">
              &lt;!&ndash;设备诊断码与websocket握手包返回的code一致时，则为本机连接中&ndash;&gt;
              <div v-if="socket && socket.code===machine.extranetCode"
                   class="local-extranet">
                <a-badge status="processing" :text="$t('page_extranet_Local')"></a-badge>
              </div>
              &lt;!&ndash;非本机连接中&ndash;&gt;
              <div v-if="machine.extranetCode" class="flag working">{{ $t('page_extranet_In_diagnosing') }}</div>
            </template>

            &lt;!&ndash; userVisibleStatus: 0未就绪/1就绪/2连接中&ndash;&gt;
            <template v-if="machine.userVisibleStatus === 1">
              <div class="flag">{{ $t('page_extranet_Ready') }}</div>
            </template>
            <template v-if="machine.userVisibleStatus === 0">
              <div class="flag err">{{ $t('page_extranet_unReady') }}</div>
            </template>

            <div class="pic">
              <img :src="machine.avatar" v-if="machine.avatar"/>
              <img :src="require('@/assets/images/default-device.png')" v-else alt=""/>
            </div>
            <a-tooltip :title="machine.name" placement="right" class="name ellipsis">
              {{ machine.name }}
            </a-tooltip>
            <a-tooltip :title="machine.equipmentSerialNumber" placement="right" class="serial-no ellipsis">
              {{ machine.equipmentSerialNumber }}
            </a-tooltip>
          </li>
          <li v-if="data.length>20&&data.length<total" style="width: 100%;height: 30px;line-height:30px;">加载更多...</li>
        </ul>
        <template v-if="(!data&&!loading) || (!data.length&&!loading)">
          <div class="empty">
            <img :src="require('@/assets/images/noDevice.png')"/>
            <p>{{ $t('page_extranet_no_device') }}</p>
          </div>
        </template>
      </div>
    </a-skeleton>-->
  </div>
  </a-spin>
</template>

<script>

import { RegionServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'

const rsp = new RegionServiceProxy()
const csp = new CustomerServiceProxy()
import { getTenantInfo } from '@/utils/auth'
import {getLocalStorage} from "@/utils/storage";
import * as _ from "lodash";

export default {
  name: 'DeviceList',
  props: {
    data: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    current: {
      type: Object,
      default: null
    },
    socket: {
      type: Object,
      default: null
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      listBusy: false,
      scrollPanel: null,
      searchKey: '', // 搜索关键词
      selectNode: '',
      departmenTreeNodes: [],
      scrollTop: 0,
      statusSearch: '3',
      treeData: [], // 客户树列表
      selectedKeys: undefined,
      treeExpandedKeys: [],
      expandedKeys: [],
      customerList: [],
      tenantClass: 0,
      machineChanged: false
    }
  },
  watch: {
    data: {
      handler (val) {
        /*if(val.length===0){
          this.searchKey= undefined;
          return;
        }
        const machine = val[0];
        this.searchKey = machine.equipmentSerialNumber || machine.name;
        */
      },
      deep: true
    }
  },
  mounted () {
    this.searchKey = this.$route.query.key;
    this.tenantClass = getLocalStorage('USER_INFO')['tenant_classes'];
    // this.addListen()
    this.getTreeList()
    /*
    setTimeout(()=>{
      if(this.searchKey){
        this.handleChangeSearch()
      }
    },500);*/

  },
  computed:{
    isMachineTenant(){
      return this.tenantClass === 4;
    }
  },
  methods: {
    handleChangeSearch(){
      if(this.machineChanged){
        this.searchKey = this.current.equipmentSerialNumber || this.current.name;
      }
      this.$emit('changeSearch', this.searchKey);
    },
    loadMore (e) {
      const scrollTop = e.target.scrollTop // 已滚动到可视区域上方的高度
      const clientHeight = e.target.clientHeight // 可视区域高度
      const scrollHeight = e.target.scrollHeight // 滚动内容的总高度
      let flag = !!(scrollHeight - (scrollTop + clientHeight) <= 10)
      if (flag && this.data.length < this.total) { // 不足10像素触发加载更多
        this.scrollTop = scrollTop
        let data = {
          type: 'more',
          searchKey: this.searchKey
        }
        this.$emit('load', data)
      }
    },
    changeCurrentDevice (machine) {
      this.machineChanged=true;
      // this.searchKey = machine.equipmentSerialNumber || machine.name;
      this.$emit('change', machine)
    },
    refreshDeviceList(){
      this.searchKey = undefined;
      this.$emit('changeSearch', this.searchKey);
    },
    selectTree(value, row) {
      if (value.length === 0) {
        return
      }
      this.selectedKeys = value
      this.$emit('changeTree', row.dataRef)
    },
    handleChangeStatus(value) {
      this.statusSearch = value
      this.$emit('changeStatus', value)
    },
    handleInfiniteOnLoad(){
      this.searchKey = this.$route.query.key;
      let data = {
        type: 'more',
        searchKey: this.searchKey
      }
      console.log('handleInfiniteOnLoad', data);
      this.$emit('load', data)
    },
    async getTreeList() {
      this.selectedKeys = undefined
      const tenant = getTenantInfo()
      const tenantCode = tenant ? tenant : '根节点'
      this.treeData = [
        {
          key: '00-00',
          id: undefined,
          value: '00-00',
          title: tenantCode,
          isLeaf: false,
          selectable: true,
          isProv: false,
          children: []
        }
      ]
      const { data } = await rsp.select()
      const children = this.expandTree(data, false, false, tenantCode)
      this.treeData[0].children = children
      this.treeExpandedKeys = ['00-00']
      this.expandedKeys = ['00-00']
      this.selectedKeys = '00-00'
    },
    expandTree(data, isLeaf, prov, pId) {
      let children = []
      if (data && data.length) {
        for (let i = 0; i < data.length; i++) {
          const node = {
            key: data[i].code,
            id: data[i].id,
            value: data[i].code,
            title: data[i].name,
            isLeaf: isLeaf,
            selectable: true,
            isProv: prov,
            pName: pId
          }
          console.log(node)
          children = children.concat(node)
        }
      }
      return children
    },
    async onLoadData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve()
          return
        }
        const data = this.expandedKeys.find((res) => res === treeNode.dataRef.id)
        if (!data) {
          const value = treeNode.dataRef.key
          const code = treeNode.dataRef.title
          if (treeNode.dataRef.isProv) {
            csp.getCustomerByRegion(code).then((res) => {
              const children = this.expandTree(res.data, true, true, code)
              treeNode.dataRef.children = children
              this.treeData = [...this.treeData]
              this.customerList = this.customerList.concat(res.data)
            })
          } else {
            rsp.select(value).then((res) => {
              const children = this.expandTree(res.data, false, true, code)
              treeNode.dataRef.children = children
              this.treeData = [...this.treeData]
            })
          }
          this.expandedKeys.push(treeNode.dataRef.id)
        }
        resolve()
      })
    },
  }
}
</script>

<style scoped lang="less">
  @import "DeviceList";
</style>
